import React from 'react';
import { SendHorizonal } from 'lucide-react';
import LineChartComponent from '@/components/charts/Line';

interface ProductCardProps {
  product: {
    产品代码: string;
    趋势表现: string;
    产品名称: string;
    赎回费: string;
    风险级别: string;
    产品策略: string;
    封闭期: string;
    优势标签: string;
    产品优势: string;
    近一年收益: string;
  };
  chartData?: Array<{ value: number }>;
  onSend?: () => void;
}

export const ProductCard: React.FC<ProductCardProps> = ({ product, chartData, onSend }) => {
  // 解析优势标签
  const tags = product.优势标签.split('、').filter(tag => tag.trim());

  // 解析风险级别
  const riskLevel = product.风险级别.split('-')[0]; // 提取 R3 部分
  const riskLevelText = product.风险级别.split('-')[1]; // 提取 中风险 部分
  return (
    <div className="rounded-lg border border-[#F0F0F0] bg-white p-3">
      {/* 产品信息头部 */}
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <span className="text-base font-semibold text-[#1F1F1F]">{product.产品名称}</span>
          <button
            onClick={onSend}
            className="flex items-center gap-1 rounded bg-gradient-to-r from-[#5D2BC7] to-[#A644CA] px-2 py-1 text-sm text-white shadow-sm"
          >
            <SendHorizonal size={16} /> 发送
          </button>
        </div>

        {/* 标签区域 */}
        <div className="flex flex-wrap gap-1">
          <span className="rounded bg-[#F0F5FF] px-2 py-0.5 text-xs text-[#595959]">
            {product.产品代码}
          </span>
          <span className="rounded bg-[#F0F5FF] px-2 py-0.5 text-xs text-[#595959]">
            {riskLevel}
          </span>
          <span className="rounded bg-[#F0F5FF] px-2 py-0.5 text-xs text-[#595959]">
            {product.封闭期}
          </span>
          {tags.map((tag, index) => (
            <div
              key={index}
              className="rounded p-[2px]"
              style={{
                background: 'linear-gradient(267deg, #3215F3 4.19%, #ECB1FF 86.14%)'
              }}
            >
              <div className="rounded bg-[#F0F5FF] px-2 text-xs text-[#595959]">{tag}</div>
            </div>
          ))}
        </div>

        {/* 产品策略 */}
        {/* <div className="text-xs text-[#8C8C8C]">
          <span className="font-medium">产品策略：</span>
          {product.产品策略}
        </div> */}
      </div>

      {/* 指标和图表区域 */}
      <div className="mt-3 flex items-center gap-3">
        {/* 图表 */}
        {chartData && (
          <div className="h-[26px] w-[82px]">
            <LineChartComponent data={chartData} stroke="#F5222D" strokeWidth={2} height="26px" />
          </div>
        )}

        {/* 指标数据 */}
        <div className="grid flex-1 grid-cols-2 gap-3">
          <div className="space-y-2">
            <div className="flex items-center gap-1">
              <span className="text-base font-semibold text-[#F5222D]">{product.近一年收益}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="text-xs text-[#1F1F1F]">近一年收益</span>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-1">
              <span className="text-base font-semibold text-[#1F1F1F]">{product.封闭期}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="text-left text-xs text-[#1F1F1F]">{product.产品策略}</span>
            </div>
          </div>
        </div>
      </div>

      {/* 产品优势 */}
      {/* <div className="mt-3 rounded bg-[#F8F9FA] p-2 text-xs text-[#1F1F1F]">
        <span className="font-medium">产品优势：</span>
        {product.产品优势}
      </div> */}

      {/* 趋势表现 */}
      {/* <div className="mt-2 rounded bg-[#F0F5FF] p-2 text-xs text-[#1F1F1F]">
        <span className="font-medium">趋势表现：</span>
        {product.趋势表现}
      </div> */}

      {/* 赎回费信息 */}
      {/* <div className="mt-2 text-xs text-[#8C8C8C]">
        <span className="font-medium">赎回费：</span>
        {product.赎回费}
      </div> */}
    </div>
  );
};

export default ProductCard;
